var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-select", {
    attrs: {
      searchable: "",
      clearable: "",
      avoidDefaultSort: "",
      loading: _vm.loadingOptions,
      options: _vm.options,
      valueProp: "id",
      label: _vm.$i18nHelpers.normalizeProp("label"),
      placeholder: _vm.placeholder
    },
    on: {
      input: _vm.onOptionSelected,
      search: function($event) {
        return _vm.search($event)
      },
      "option:selected": function($event) {
        return _vm.$emit("option:selected", $event)
      }
    },
    scopedSlots: _vm._u(
      [
        _vm.options && _vm.options.length > 0
          ? {
              key: "option",
              fn: function(data) {
                return [
                  _c("div", [
                    _c("img", {
                      staticClass: "photo-option",
                      class: {
                        "professional-photo": _vm.isProfessionalOption(
                          data.option.value
                        )
                      },
                      attrs: {
                        id: _vm.getPhotoElementId(data.option.value),
                        src: _vm.getPhoto(data.option.value)
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(data.option.label))])
                  ])
                ]
              }
            }
          : null
      ],
      null,
      true
    ),
    model: {
      value: _vm.selectValue,
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-315b8881", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315b8881","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MultipleSearchSelector.vue
// module id = 3202
// module chunks = 52 71